import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { BOX_IDEAS } from './salesData';
import { PACKAGING_IMAGE_URL } from '../utils/headMeta';
export function BenefitsSection() {
  return <section id="boxes" className="bg-sand py-14 sm:py-20" data-id="element-49" data-mp="3ipf2rowlhd4q">
      <div className="mx-auto max-w-6xl px-5" data-id="element-50" data-mp="3np1fzycfatdj">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:items-center lg:gap-14" data-id="element-51" data-mp="3nnqc7yiz9lmf">
          <img src={PACKAGING_IMAGE_URL} alt="Cajas modernas de postres en blanco y rosa, con cinta y bombones surtidos" loading="lazy" decoding="async" width={1200} height={800} className="order-2 h-full w-full rounded-3xl object-cover shadow-[0_30px_60px_-34px_rgba(56,37,34,0.5)] lg:order-1" data-id="element-52" data-mp="38qpkvw4p7soh" />

          <div className="order-1 lg:order-2" data-id="element-53" data-mp="y0qzdhgtkfua">
            <SectionTag className="bg-white" data-id="element-54" data-mp="12zlspdcexmsn">12 boxes y combos</SectionTag>
            <h2 className="mt-4 max-w-[20ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2.4rem]" data-id="element-55" data-mp="12wptllotws2m">
              Los mismos productos, presentados de una forma que{' '}
              <span className="text-gold" data-id="element-56" data-mp="2l4pejxvsbhxo">vale más</span>.
            </h2>
            <p className="mt-4 max-w-[48ch] font-sans text-[0.92rem] leading-relaxed text-taupe sm:text-[1rem]" data-id="element-57" data-mp="2l6tkeld8ur0l">
              Combinar es la manera más simple de subir el valor de cada pedido sin sumar recetas
              nuevas. Estas son algunas de las ideas que vas a encontrar dentro del libro.
            </p>

            <div className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-58" data-mp="22e7sud9ddmlt">
              {BOX_IDEAS.map((box, i) => <motion.div key={box.title} initial={{
              opacity: 0,
              y: 12
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-60px'
            }} transition={{
              duration: 0.28,
              ease: [0.23, 1, 0.32, 1],
              delay: Math.min(i, 4) * 0.04
            }} className="rounded-2xl border border-stone bg-white p-4 shadow-[0_10px_28px_-24px_rgba(56,37,34,0.5)]" data-id="element-59" data-mp="1xev6dtmeuhjr" data-mpi={i}>
                  <h3 className="font-display text-[0.9rem] font-bold tracking-tight text-charcoal" data-id="element-60" data-mp="3pwqnrwaplfx8">
                    {box.title}
                  </h3>
                  <p className="mt-1.5 font-sans text-[0.82rem] leading-relaxed text-taupe" data-id="element-61" data-mp="2x81kbqm6kyib">
                    {box.desc}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}